import { render, staticRenderFns } from "./associatedClinics.vue?vue&type=template&id=e23b297e&"
import script from "./associatedClinics.vue?vue&type=script&lang=js&"
export * from "./associatedClinics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports